import React, { Component, Fragment } from 'react';
import Header from './Header';
import CSVGenerator from '../utils/json2csv';
import _ from 'lodash';
import moment from 'moment';
import SelectTable from './SelectTable';
import Table from './Table';
import { getPaymentsReport, getAccountingReport, handleAccountingStatus } from '../utils/PaymentRequestApiUtils';
import { TextField, Button, Snackbar, LinearProgress, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@material-ui/core';
import userdata from '../config/jwt_token'
import { getPaymentsReportCSVData, getAccountingReportCSVData } from './Reports';
import { accountingReportStatusMap } from '../constants/paymentStatus';

class AccountingReport extends Component {
	constructor() {
		super();
		this.state = {
			data: [],
			fromDate: '',
			toDate: '',
			fromDateShow: '',
			toDateShow: '',
			fromDateErr: false,
			fromDateErrText: '',
			toDateErr: false,
			toDateErrText: '',
			inProgress: false,
			snackMessage: "",
			snackOpen: false,
			validationsDialogOpen: false,
			validationErrors: [],
			dialogBoxText: "",
			showDownloadButton: false,
			paymentsReportColumns: [],
			accountingReportColumns: [],
			tableState: {
				selectedData: [],
				selection: [],
				selectAll: false
			},
			pageIndex: 0,
			disableARStatusBtn: true,
			approveDialogBox: false,
			approveddialogBoxTitle: '',
			approveddialogBoxText: '',
			comment: undefined,
			commentErr: false,
			commentErrText: '',
			confirmDialogOpen: false,
			confirmDialogTitle: '',
			confirmDialogText: '',
			confirmDialogCancelBtnText: 'Cancel',
			confirmDialogOkBtnText: 'Confirm',
			confirmDialogViewMode: '',
			disableAccountingInit: true
		}
		this.handleChange = this.handleChange.bind(this);
		this.submitFilter = this.submitFilter.bind(this);
		this.clearFilter = this.clearFilter.bind(this);
		this.generateCSV = this.generateCSV.bind(this);
		this.handleCloseSnack = this.handleCloseSnack.bind(this);
		this.handleFetchData = this.handleFetchData.bind(this);
	}

	componentWillMount() {
		if (userdata) {
			let role = userdata.role;
			const updateStateData = {};
			if (role !== 'City Finance') {
				updateStateData.showDownloadButton = true;
				updateStateData.paymentsReportColumns = this.props.location.state.paymentsReportColumns;
				updateStateData.accountingReportColumns = this.props.location.state.accountingReportColumns;
			}

			if (role === 'root' || role === 'City Head') {
				updateStateData.disableAccountingInit = false;
			}
			this.setState(updateStateData);
		}
	}
	componentDidMount() {
		this.handleFetchData()
	}

	handleChange = (props) => (event, index, value) => {
		this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })
	}

	async submitFilter() {

		if (this.state.toDateShow !== '' && this.state.toDateShow < this.state.fromDateShow) {
			this.setState({ snackOpen: true, snackMessage: 'From date should be less than To date' })
			return
		}

		if (this.state.fromDateShow !== '' && this.state.fromDateShow > this.state.toDateShow) {
			this.setState({ snackOpen: true, snackMessage: 'To date should be greater than From date' })
			return
		}
		this.setState({ fromDate: this.state.fromDateShow, toDate: this.state.toDateShow }, () =>
			this.handleFetchData({ from_date: this.state.fromDate, to_date: this.state.toDate })
		)

	}

	handleFetchData(filters = {}) {
		this.setState({ inProgress: true }, () => {
			getAccountingReport(filters).then(response => {
				if (response) {
					if (response.status === 'success') {
						let data = response.data.map(data => {
							return {
								...data,
								accounting_status_date: data.accounting_status_date ? moment(data.accounting_status_date).format('YYYY-MM-DD hh:mm A') : '',
								accounting_status: data.accounting_status ? accountingReportStatusMap[data.accounting_status].value : 'Unaccounted',
								approver1_date: data.approver1_date ? moment(data.approver1_date).format('YYYY-MM-DD'): '',
								transaction_date: (data.transaction_date) ? moment(data.transaction_date).format('YYYY-MM-DD') : data.transaction_date,
								payment_request_date: (data.payment_request_date) ? moment(data.payment_request_date).format('YYYY-MM-DD') : data.payment_request_date,
								invoice_due_date: (data.invoice_due_date) ? moment(data.invoice_due_date).format('YYYY-MM-DD') : data.invoice_due_date,
							}
						})
						this.setState({ 
							data, 
							inProgress: false,
							tableState: {
								selection: [],
								selectedData: [],
								selectAll: false,
							},
							disableARStatusBtn: true,
							confirmDialogOpen: false
						})
					}
					else {
						this.setState({ 
							snackMessage: response.message, 
							snackOpen: true, 
							inProgress: false,
							tableState: {
								selection: [],
								selectedData: [],
								selectAll: false,
							},
							disableARStatusBtn: true,
							confirmDialogOpen: false
						})
					}
				}
			})
		})
	}


	handleCloseSnack() {
		this.setState({ snackOpen: false })
	}

	clearFilter() {
		this.setState({ fromDate: '', toDate: '', fromDateShow: '', toDateShow: '', fromDateErr: false, fromDateErrText: '', toDateErr: false, toDateErrText: '' })
		this.handleFetchData();
	}

	async generateCSV() {
		let csvData = await getAccountingReportCSVData(
			this.state.data, 
			{ 
				from_date: this.state.fromDate ? this.state.fromDate : moment().startOf('month').format("YYYY-MM-DD"), 
				to_date: this.state.toDate ? this.state.toDate : moment().endOf('month').format("YYYY-MM-DD")
			});
		CSVGenerator(csvData.headers, csvData.data, csvData.filename)
	}

	generateAllCSVs() {
		let paymentsReportCSVData = {};
		this.generateCSV();
		getPaymentsReport({ from_date: this.state.fromDate, to_date: this.state.toDate }).then(response => {
			if (response) {
				if (response.status === 'success') {
					let paymentsReportData = response.data.map(data => {
						return {
							...data,
							transaction_date: (data.transaction_date) ? moment(data.transaction_date).format('YYYY-MM-DD') : data.transaction_date,
						}
					})
					this.setState({ paymentsReportData });
				}
				else {
					this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
				}
			}
		}).then(async () => {
			paymentsReportCSVData = await getPaymentsReportCSVData(this.state.paymentsReportData);
		}).then(() => CSVGenerator(paymentsReportCSVData.headers, paymentsReportCSVData.data, paymentsReportCSVData.filename));
	}

	updateSelected = (selections, selectedData, selectAll = false) => {
		// we need to enable the button and keep it enabled for selected > 0
		let selected;
		if (!selectedData.length) { selected = true }
		else { selected = false }
		this.selectedData = selectedData;
		this.setState({
			tableState: {
				selection: selections,
				selectedData: selectedData,
				selectAll: selectAll,
			},
			disableARStatusBtn: selected
		})
	}

	tablePageChangehandler = (event) => {
    this.setState({ pageIndex: event });
  }

	handleOk = async () => {
		this.clearFilter()
	}

	handleAccountingInit = () => {
		this.setState({
			confirmDialogOpen: true,
			confirmDialogTitle: 'Accounting Init',
			confirmDialogText: `Are you sure you want to mark the selected payments as accounted?`,
			confirmDialogOkBtnText: 'Confirm',
			confirmDialogViewMode: 'accountingInit'
		})
	}

	handleNo = () => {
		this.setState({ approveDialogBox: false, comment: undefined, commentErr: false, commentErrText: ''})
	}

	handleYes = () => {
		if (this.state.comment === undefined || this.state.comment === '')
			this.setState({ commentErr: true, commentErrText: 'Please add a comment' })
		else
			this.setState({ inProgress: true }, this.handleARStatusChange);
	}

	clearErr = () => {
		this.setState({ commentErr: false, commentErrText: '' })
	}

	handleComment = (event) => {
		this.setState({ comment: event.target.value });
	}

	handleARStatusChange = async () => {
		try {
			this.setState({ confirmDialogOpen: false})
			let body = {
				paymentRequestIds: this.state.tableState.selection
			};
			const respData = await handleAccountingStatus(body);
			if(respData.flag) {
				this.setState({
					confirmDialogOpen: true,
					confirmDialogTitle: 'Accounting Init',
					confirmDialogText: respData.message || `Selected payments have been accounted successfully`,
					confirmDialogOkBtnText: 'OK',
					confirmDialogViewMode: 'accountingInitResp'
				})
			}

		} catch (error) {
			console.log(error);
		}
	}

	handleConfirmOfConfirmDialog = () => {
		if(this.state.confirmDialogViewMode === 'accountingInit') {
			this.handleARStatusChange();
			return;
		}

		if(this.state.confirmDialogViewMode === 'accountingInitResp') {
			this.setState({ 
				confirmDialogOpen: false, 
				inProgress: false,
			});
			this.clearFilter();
			return;
		}
	}

	render() {
		return (
			<Fragment>
				<Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Accounting Report</h2>
              <p className="zaps-page-subtitle">GST mapping and accounting status</p>
            </div>
          </div>
				<h4 style={{ textAlign: 'center' }}>Details showing from {this.state.fromDate && this.state.toDate ? this.state.fromDate : moment().startOf('month').format("YYYY-MM-DD")} to {this.state.toDate && this.state.fromDate ? this.state.toDate : moment().endOf('month').format("YYYY-MM-DD")}</h4>
				<div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						<div>
							Select L1 Approval Date Range:&nbsp;&nbsp;&nbsp;&nbsp;
							<TextField
								id="date"
								label="From Date"
								type="date"
								InputLabelProps={{
									shrink: true,
								}}
								value={this.state.fromDateShow}
								onChange={this.handleChange('fromDateShow')}
								style={{ marginRight: '20px' }}
								error={this.state.fromDateErr}
								helperText={this.state.fromDateErrText}
								margin='normal'
							/>
							<TextField
								id="date"
								label="To Date"
								type="date"
								InputLabelProps={{
									shrink: true,
								}}
								value={this.state.toDateShow}
								onChange={this.handleChange('toDateShow')}
								style={{ marginRight: '20px' }}
								error={this.state.toDateErr}
								helperText={this.state.toDateErrText}
								margin='normal'
							/>
						</div>
						<div>
							<Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' || this.state.toDateShow === ''} onClick={this.submitFilter.bind(this)}
								style={{ marginRight: '20px', marginTop: '25px' }}>
								Submit Filter
							</Button>
							<Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' && this.state.toDateShow === ''} onClick={this.clearFilter.bind(this)}
								style={{ background: 'red', marginTop: '25px' }}>
								Clear Filter
							</Button>
						</div>
					</div>
					<div style={{ marginTop: '25px' }} >
						{this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateCSV.bind(this)}
							style={{ marginRight: '20px' }}>
							Download CSV
						</Button>}
						{/* {this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateAllCSVs.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download ALL
                    </Button>} */}
					</div>
				</div>
				{this.state.disableAccountingInit ? (
					<Table
						columns={this.state.accountingReportColumns}
						data={this.state.data}
					/>
				) : (
					<Fragment>
						<SelectTable
							columns={this.state.accountingReportColumns}
							data={this.state.data}
							updateSelected={this.updateSelected}
							tablePageChangehandler={this.tablePageChangehandler}
							pageIndex={this.state.pageIndex}
							handleOk={this.handleOk}
							selection={this.state.tableState.selection}
							selectedData={this.state.tableState.selectedData}
							selectAll={this.state.tableState.selectAll}
							viewMode={"accountingReport"}
						/>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								marginTop: '20px',
								marginRight: '30px'
							}}
						>
							<Button
								variant="contained"
								size="large"
								color="primary"
								disabled={this.state.disableARStatusBtn}
								onClick={this.handleAccountingInit}
							>
								Accounting Init
							</Button>
    </div>
					</Fragment>
				)}
				<Dialog
					open={this.state.inProgress}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogContent>
						Loading...
						<br /><br />
						<LinearProgress />
					</DialogContent>
				</Dialog>
				<Dialog
					open={this.state.approveDialogBox}
					onClose={this.handleNo}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="form-dialog-title">{this.state.approveddialogBoxTitle}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{this.state.approveddialogBoxText}
						</DialogContentText>
						<TextField
							autoFocus
							onClick={this.clearErr}
							onChange={this.handleComment}
							helperText={this.state.commentErrText}
							error={this.state.commentErr}
							margin="dense"
							id="comment"
							label="*Comment"
							type="text"
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleNo} color="primary">
							No
						</Button>
						<Button onClick={this.handleYes} color="primary" autoFocus>
							Yes
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={this.state.confirmDialogOpen}
					onClose={this.handleCancelOfConfirmDialog}
					aria-labelledby="confirm-dialog-title"
					aria-describedby="confirm-dialog-description"
				>
					<DialogTitle id="confirm-dialog-title">
						{this.state.confirmDialogTitle}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="confirm-dialog-description">
							{this.state.confirmDialogText}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleCancelOfConfirmDialog} color="primary">
							{this.state.confirmDialogCancelBtnText || 'Cancel'}
						</Button>
						<Button
							onClick={this.handleConfirmOfConfirmDialog}
							color="primary"
							autoFocus
						>
							{this.state.confirmDialogOkBtnText || 'Confirm'}
						</Button>
					</DialogActions>
				</Dialog>
				<Snackbar
					open={this.state.snackOpen}
					message={this.state.snackMessage}
					autoHideDuration={2500}
					onClose={this.handleCloseSnack.bind(this)}
				/>
          
        </div>{/* end zaps-page-wrap */}
      </Fragment>
		)
	}
}

export default AccountingReport;



// WEBPACK FOOTER //
// ./src/components/AccountingReport.js